import { useEffect } from 'react';
import { useState } from 'react';
import API from '../../API';
import TasksTextsView from '../TasksTextsView';
import HeaderTest from './HeaderTest';
import {ru} from "../../data/ru";
import {by} from "../../data/by";
import {useParams} from "react-router-dom";
import { ReactComponent as ArrowIcon } from '../../../img/arrow-feedback.svg';
import {COMPLEX_CREATOR_URL} from "../../../config";

export default function TestCreator() {
  let language = localStorage.getItem('lang') === 'ru' ?  ru.RoleIdThree: by.RoleIdThree;

  const { id } = useParams();

  const api = new API()

  const [visibleTest,setVisibleTest]=useState([])
  const [name,setName] = useState('')
  const [questions, setQuestions] = useState([])
  const [testQuestions, setTestQuestions] = useState([]);
  const [headerTest, setHeaderTest] = useState({})
  const [defaultTest,setDefaultTest]=useState({})


  useEffect(() => {
    api.getComplexTasks().then(data => {
      if(!data) {return}
      setQuestions(
          data,
      )
    })
  }, [])
  useEffect(()=>{
    if(id) {
      api.getTest(id,true).then(data => {
          if(!data){return}
        setDefaultTest(data)
        setTestQuestions([...data.tasks])
      })
    }
  },[id])

  useEffect(() => {
    if (name !== '') {
      const arrQuestion = questions.filter(question => question.name.toLowerCase().includes(name.toLowerCase()));
      setVisibleTest(arrQuestion);
    } else {
      setVisibleTest(questions);
    }
  }, [name, questions]);

  function changeName(e) {
    setName(e.target.value)
  }
  function addHeaderTest(requestOptions) {
    setHeaderTest(requestOptions)
  }

  function addQuestion(item) {
    setTestQuestions(prev => [...prev, item])
  }
  function editQuestion(id) {
    window.location.href=COMPLEX_CREATOR_URL+id
  }

  function deleteQuestion(question) {
    let isOk = window.confirm('Вы уверенны, что хотите удалить Комплексное задание?');
    if(isOk) {
      api.deleteComplexTask(question.id)
      setQuestions(questions => {
        return questions.filter(item => item.id !== question.id)
      })
      // setQuestions(questions => {
      //   return questions.filter(item => item.id !== text.id)
      // })
    }
  }

  function deleteQuestionFromTest(id) {
    setTestQuestions(testQuestions => {
      return testQuestions.filter(item => item.id !== id)
    })
  }

  function upFunction(index) {
    if (index !== 0) {
      setTestQuestions((prevQuestions) => {
        const arrQuestions = [...prevQuestions];
        const prevItem = arrQuestions[index - 1];//предыдущий элемент, который будем заменять
        arrQuestions[index - 1] = arrQuestions[index];
        arrQuestions[index] = prevItem;
        return arrQuestions;
      });
    }
  }

  function downFunction(index) {
    if (index !== testQuestions.length - 1) {
      setTestQuestions((prevQuestions) => {
        const arrQuestions = [...prevQuestions];
        const nextItem = arrQuestions[index + 1]; //следующий элемент, который будем заменять
        arrQuestions[index + 1] = arrQuestions[index];
        arrQuestions[index] = nextItem;
        return arrQuestions;
      });
    }
  }
  const showQuestions = visibleTest?.map((item, i) => {
    if (testQuestions.find(el => el.id === item.id)) {
      return null
    }

    const text = <><p>{item.name}</p> <p>{item.description}</p></>

    return <TasksTextsView key={`visible${item.id}`} item={item} add={addQuestion} edit={editQuestion} deleteI={deleteQuestion} textTitle="Задание:" text={text}/>
  })

  let test = testQuestions.map((item,index) => {
    // const text = ReturnTextAndImg(item.description,{maxHeight:'50px'})
    return <div key={`visible${item.id}`} className="test-creator-one-question">
      <div className="test-creator-question-create">
        <div className={'test-creator-question-name-header'}>
          <button onClick={() => deleteQuestionFromTest(item.id)} className="test-creator-test-closeButton">&times;</button>
          <div className="test-creator-test-question-p"><p>{item.name}</p><p>{item.description}</p></div>
        </div>
        <div className="test-creator-up-down-button">
          <span onClick={()=>upFunction(index)}><ArrowIcon className={'upArrow'}/></span>
          <span onClick={()=>downFunction(index)}><ArrowIcon/></span>
        </div>
      </div>      
    </div>
  })

  async function addTest(requestOptions) {
    let api = new API()
    const requestProps = testQuestions.map(item => item.id)
    if(id){
      const props = {
        name:requestOptions.name,
        description:requestOptions.description,
        exame_time: requestOptions.exame_time,
        tasks: requestProps,
      }
      await api.editTest(id,props)

    }
    else {
      await api.addTest(requestOptions, requestProps)
    }
  }

  return (
    <div className="test-creator-background">
      <div className="test-creator-main"> 
        <div className="test-creator-container">

          <input type={'text'} onChange={e=>changeName(e)} value={name}/>
          <div className="test-creator-constructor">
            <div className="test-creator-questions">
              {showQuestions}
            </div>

            <div className="test-creator-test">
              <HeaderTest addHeaderTest={addHeaderTest}
                          name={defaultTest.name}
                          description={defaultTest.description}
                          exame_time={defaultTest.time}/>
              <p>{language.blockTest}: </p>
              {test}
              <button className="test-creator-button-send" onClick={() => addTest(headerTest)} disabled={!Boolean(testQuestions.length)}>{language.sendButton}</button>
            </div>
              </div>
            </div>
          </div>
        </div>
  )

}